import { useEffect } from 'react';
import { compose } from 'ramda';
import { useDispatch, useSelector } from 'react-redux';

import { hasPermissionByIds } from '@gef-ui/cdu-user/selectors';

import Panel from 'components/atoms/GefMui/Panel';
import PaperWithToolbar from 'components/atoms/GefMui/PaperWithToolbar';
import { codelistProvider } from 'components/index';
import { codelists } from 'constants/codelists';
import MODALS from 'constants/modals';
import PAGES from 'constants/pages';
import { KMP_NEW_CAMPAIGN } from 'features/common/acl/constants';
import { subheaders } from 'features/common/Subheader/constants';
import { getVisibleStateById } from 'features/common/Subheader/selectors';
import { startupCampaignsList } from 'features/views/campaignList/actions';

import Filter from './components/Filter';
import Table from './components/Table';
import Toolbar from './components/Toolbar';
import NewCampaignModal from './modals/NewCampaignModal';

export const CampaignsList = () => {
	const dispatch = useDispatch();

	const newOrEditCampaignPermission = useSelector((state) => hasPermissionByIds(state)(KMP_NEW_CAMPAIGN));
	const isCampaignSettings = window.location.pathname === '/campaign/settings/list';
	const visibleState = useSelector((state) => getVisibleStateById(state, subheaders.campaignsList, false));

	useEffect(() => {
		dispatch(startupCampaignsList());
	}, [dispatch]);

	return (
		<Panel screenId={PAGES.campaignList.id} screenName={PAGES.campaignList.name}>
			<NewCampaignModal id={MODALS.new_campaign} />
			<PaperWithToolbar
				toggledElement={<Filter />}
				toolbar={<Toolbar />}
				collapsibleProps={{ id: subheaders.campaignsList, initiallyOpen: visibleState }}
			>
				<Table
					isCampaignSettings={isCampaignSettings}
					newOrEditCampaignPermission={newOrEditCampaignPermission}
				/>
			</PaperWithToolbar>
		</Panel>
	);
};

export default compose(
	codelistProvider(codelists.campaignChannels),
	codelistProvider(codelists.campaignStates),
)(CampaignsList);
